//Main
import vuex from "vuex"
import vue from "vue"
import vapi from "vuex-rest-api"
import store from "./index.js"
vue.use(vuex);

//store
const indicador = new vapi({
    baseURL: `${process.env.VUE_APP_REST}/api/indicador`,
    state: {
        Aindicador: null,
        Aindicadores: null,
        indicadoresreducido: null
        , error: ""
        , warn: ""
        , Metasgeneradas: null,
        Aindicadoravances: null,
        AIndicadorFlujo:null,
        IndicadoresPDET:null,
        IndicadorTerritorializacion: [],
        Elementosprocesados: ''
    }
}).get({
    action: "get_indicadores",   
    onSuccess: (state, payload) => {
        state.Aindicadores = payload.data;
    },
    onError: (state, error) => {
        store.dispatch("mensaje/set_error", error);
        state.Aindicadores = []
    }
}).get({
    action: "get_avancesAdmin",  
    path: function (obj) { return `/adminavances/${obj.idindicador}` },  
    onSuccess: (state, payload) => {
        state.Aindicadoravances = payload.data;
    },
    onError: (state, error) => {
        store.dispatch("mensaje/set_error", error);
        state.Aindicadoravances = []
    }
}).get({
    action: "get_indicadorbyterritorializacion",  
    path: function () { return `/indicadoresporterritorializacion` },  
    onSuccess: (state, payload) => {
        state.IndicadorTerritorializacion = payload.data;
    },
    onError: (state, error) => {
        store.dispatch("mensaje/set_error", error);
        state.IndicadorTerritorializacion = []
    }
}).get({
    action: "get_indicadoresreducido",  
    path: function () {
        return `/reducido`
    }, 
    onSuccess: (state, payload) => {
        state.indicadoresreducido = payload.data;
    },
    onError: (state, error) => {
        store.dispatch("mensaje/set_error", error);        
    }
}).get({
    action: "get_indicador",
    path: function (obj) {
        return `/${obj.idindicador}`
    },
    onSuccess: (state, payload) => {
        state.Aindicador = payload.data;
    },
    onError: (state, error) => {
        store.dispatch("mensaje/set_error", error);
        state.Aindicador = []
    }
}).get({
    action: "get_indicadoresporusuario",
    path: function () {
        return `/seguridad`
    },
    onSuccess: (state, payload) => {
        state.Aindicadores = payload.data;
    },
    onError: (state, error) => {
        store.dispatch("mensaje/set_error", error);
        state.Aindicadores = []
    }
    
}).get({
    action: "Indicador_Encabezado",
    path: function (obj) {
        return `/encabezado/${obj.idindicador}`
    },
    onSuccess: (state, payload) => {
        state.Aindicador = payload.data;
    }
}).get({
    action: "Avance_Encabezado",
    path: function (obj) {
        return `/avanceencabezado/${obj.idindicador}`
    },
    onSuccess: (state, payload) => {
        state.Aindicador = payload.data;
    }
}).get({
    action: "get_indicadoresestrategia",
    path: function (obj) {
        return `/detalle/estrategia/${obj.idestrategia}/${obj.idperiodo}`
    },
    onSuccess: (state, payload) => {
        state.Aindicadores = payload.data;
    }
}).get({
    action: "get_indicadorespuntoclasificacion",
    path: function (obj) {
        return `/detalle/punto/${obj.idpunto}/clasificacion/${obj.idclasificacion}/${obj.idperiodo}`
    },
    onSuccess: (state, payload) => {
        state.Aindicadores = payload.data;
    }
}).get({
    action: "get_indicadorespilar",
    path: function (obj) {
        return `/detalle/pilar/${obj.idpilar}/${obj.idperiodo}`
    },
    onSuccess: (state, payload) => {
        state.Aindicadores = payload.data;
    }
}).get({
        action: "get_indicadoresentidad",
        path: function (obj) {
            return `/detalle/entidad/${obj.identidad}/${obj.idperiodo}`
        },
        onSuccess: (state, payload) => {
            state.Aindicadores = payload.data;

        },
        onError: (state, error) => {
            store.dispatch("mensaje/set_error", error);
            state.Aindicadores = []
        }
}).get({
        action: "get_indicadoreslinea",
        path: function (obj) {
            return `/detalle/linea/${obj.idlinea}/${obj.idperiodo}`
        },
        onSuccess: (state, payload) => {
            state.Aindicadores = payload.data;
        }
}).get({
    action: "get_indicadorbycategoria",
    path: function (obj) {
        return `/byclasificador/${obj.idclasificador}`
    },
    onSuccess: (state, payload) => {
        state.Aindicadores = payload.data;
    }
}).get({
        action: "get_indicadoresproducto",
        path: function (obj) {
            return `/detalle/producto/${obj.idproducto}/${obj.idperiodo}`
        },
        onSuccess: (state, payload) => {
            state.Aindicadores = payload.data;
        }
}).get({
    action: "get_indicadorbycodigo",
    path: function (obj) {
        return `/indicadorporcodigo/${obj.codigo}`
    },
    onSuccess: (state, payload) => {
        state.AIndicadorFlujo = payload.data;
    }
}).get({
    action: "get_indicadoresPDET",
    path: function (obj) {
        return `geoindicadores/${obj.idsubregion}/${obj.departamento}/${obj.idmunicipio}/${obj.idpunto}/${obj.idclasificador}/${obj.idinstrumento}/${obj.idperiodo}`
    },
    onSuccess: (state, payload) => {
        state.IndicadoresPDET = payload.data;
    },
    onError: (state, error) => {
        store.dispatch("mensaje/set_error", error);
        state.IndicadoresPDET = []
    }
}).get({
    action: "get_RecalcularPMIGeneral",
    path: function (obj) {
        return `recalcularpmi/${obj.idestado}`
    },
    onSuccess: (state, payload) => {
        state.Elementosprocesados = payload.data;
    },
    onError: (state, error) => {
        store.dispatch("mensaje/set_error", error);
        state.Elementosprocesados = '';
    }
}).get({
    action: "get_RecalcularPMIporAcumulacion",
    path: function (obj) {
        return `recalcularpmi/${obj.idacumulacion}/${obj.idestado}`
    },
    onSuccess: (state, payload) => {
        state.Elementosprocesados = payload.data;
    },
    onError: (state, error) => {
        store.dispatch("mensaje/set_error", error);
        state.Elementosprocesados = '';
    }
}).put({
    action: "get_RecalcularPMIporindicador",
    path: function (obj) {
        return `recalcularindicadorespmi/`
    },
    onSuccess: (state, payload) => {
        state.Elementosprocesados = payload.data;
    },
    onError: (state, error) => {
        store.dispatch("mensaje/set_error", error);
        state.Elementosprocesados = '';
    }
}).put({
        action: "PutIndicador",
        onSuccess: (state, payload) => {
            store.dispatch("mensaje/set_success", payload);
        },
        onError: (state, error) => {
            state.Aindicador.finalizar = false;
            store.dispatch("mensaje/set_error", error);
        }
}).put({
        action: "GenerarMetas",
        path: function () {
            return `/generarmetas/`
        },
        onSuccess: (state, payload) => {
            state.Metasgeneradas = payload.data;
        },
        onError: (state, error) => {
            store.dispatch("mensaje/set_error", error);
        }
}).put({
    action: "actualizarmetas",
    path: function () {
        return `/ActualizarMetas`
    },
    onSuccess: (state, payload) => {
        store.dispatch("mensaje/set_success", payload);
    },
    onError: (state, error) => {
        state.Aindicador.finalizar = false;
        store.dispatch("mensaje/set_error", error);
    }
}).put({
    action: "RecalcularMeta",
    path: function (obj) {
        return `avance/calcular/${obj.idusuario}`
    },
    onSuccess: (state, payload) => {
        store.dispatch("mensaje/set_success", payload);
    },
    onError: (state, error) => {
        store.dispatch("mensaje/set_error", error);
    }
}).put({
    action: "GenerarExtemporaneos",
    path: function () {
        return `avance/avancesextemporaneos/`
    },
    onSuccess: (state, payload) => {
        store.dispatch("mensaje/set_success", payload);
    },
    onError: (state, error) => {
        store.dispatch("mensaje/set_error", error);
    }
}).getStore();

indicador.getters = {
    gindicadores: state => {
        return state.Aindicadores;
    },
    gindicadoresreducido: state => {
        return state.indicadoresreducido;
    },
    gindicador: state => {
        return state.Aindicador;
    },
    gactualizarmetas: state => {
        return state.Metasgeneradas;
    },
    gindicadores_error: state => {
        return state.error;
    },
    gindicadores_warn: state => {
        return state.warn;
    },
    gavancesadmin: state => {
        return state.Aindicadoravances;
    },
    gindicadorflujo: state => {
        return state.AIndicadorFlujo;
    },
    gindicadoresPDET: state => {
        return state.IndicadoresPDET;
    },
    gindicadoresterritorializacion: state => {
        return state.IndicadorTerritorializacion;
    },
    gindicadoresmensaje: state => {
        return state.Elementosprocesados.mensajeRespuesta;
    }
}

export default indicador;